module.exports = __webpack_public_path__ + "static/img/logoz.19e4672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoz.png
// module id = MMXz
// module chunks = 12